<template>
  <div>
    <div>{{ row.deliveryNotes }}</div>
    <div>
      <span v-for="(value, key) in deliveryDays" :key="key">
        <span :class="{ 'text-red': key === 'X' }"
          ><b>{{ key }}</b
          >:{{ value }}
        </span>
      </span>
    </div>
    <div v-if="exclusion">
      <span><b>Ex</b>:{{ exclusion }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tdDeliveryNotes',
  props: ['row'],
  computed: {
    deliveryDays() {
      if (this.row.deliveryDays.deliveryWindowsEmpty) {
        return { X: 'X' };
      }

      const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
      return days.reduce((memo, day) => {
        // Use 1 char for M,W,F, and 2 chars needed for Tu/Th
        const key = day[0] === 'T' ? day.slice(0, 2) : day[0];
        const value = this.formatDeliveryTimes([
          this.row.deliveryDays[`${day.toLowerCase()}Start`],
          this.row.deliveryDays[`${day.toLowerCase()}End`],
        ]);
        memo[key] = value;
        return memo;
      }, {});
    },
    exclusion() {
      if (this.row.deliveryDays.exclusionStart) {
        return this.formatDeliveryTimes([
          this.row.deliveryDays.exclusionStart,
          this.row.deliveryDays.exclusionEnd,
        ]);
      }
    },
  },
  methods: {
    formatDeliveryTimes(times) {
      if (times[0]) {
        // The account is open on this day
        return times
          .map((time) => {
            var t = moment.utc(time);
            // If the minutes are 00, just show the hour. Otherwise show hours and minutes
            return t.minute() === 0 ? t.format('h') : t.format('h:mm');
          })
          .join('-');
      } else {
        // the account is closed this day
        return 'x';
      }
    },
  },
};
</script>

<style scoped>
.text-red {
  color: rgb(226, 0, 0);
}
</style>



// WEBPACK FOOTER //
// src/components/OrderTable/components/tdDeliveryNotes.vue